import { z } from 'zod';
import { DynamicBaseDTO } from './DynamicBaseDTO';

export const DynamicUrlDTO = DynamicBaseDTO.extend({
    url: z.string(),
});

export type DynamicUrlDTO = z.infer<typeof DynamicUrlDTO>;
